export default __webpack_public_path__ + "locales/ko-KR/ChangePasswordDialog.json?hash=a539ddf77812561a54050d75f67632e4";